import { paginationActions, requestActions } from "./utils";

export const ACTIVITY_LOG = requestActions("ActivityLog/List");
export const ACTIVITY_LOG_PAGINATION = paginationActions(
  "ActivityLog/List/Paginate",
);
